import img1 from './img-1.jpg'
import img2 from './img-2.png'
const SliderData = [
    {
        image: img1,
        title: "NITA LITERARY CLUB",
        text: `We stand for W.I.S.H Wisdom Inspiration Serenity Hardwork`
    },
    {
        image: img2,
        // title: "NITA LITERARY CLUB",
        // text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptate nostrum, optio voluptatum"
    },
    {
        image:
            'https://images.unsplash.com/photo-1483729558449-99ef09a8c325?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=80',
        title: "NITA LITERARY CLUB",
        text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptate nostrum, optio voluptatum"
    },
    {
        image:
            'https://images.unsplash.com/photo-1639967294864-8ce4f9a8ef80?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1932&q=80',
        title: "NITA LITERARY CLUB",
        text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptate nostrum, optio voluptatum"
    },
    {
        image:
            'https://images.unsplash.com/photo-1458869612855-bb6009d50368?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80',
        title: "NITA LITERARY CLUB",
        text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptate nostrum, optio voluptatum"
    },
];

export default SliderData;